import "core-js/modules/es.array.push.js";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import errGif from '@/assets/401-images/401.gif';
let default_1 = class extends Vue {
  constructor() {
    super(...arguments);
    this.errGif = errGif + '?' + +new Date();
    this.ewizardClap = 'https://wpimg.wallstcn.com/007ef517-bafd-4066-aae4-6883632d9646';
    this.dialogVisible = false;
  }
  back() {
    if (this.$route.query.noGoBack) {
      this.$router.push({
        path: '/dashboard'
      });
    } else {
      this.$router.go(-1);
    }
  }
};
default_1 = __decorate([Component({
  name: 'Page401'
})], default_1);
export default default_1;